/* Component Dependencies */
var floorplanLayoutTemplate = require('templates/floorplanLayout.hbs');
var floorplanLayoutPrintTemplate = require('templates/floorplanLayout-print.hbs');
var floorplanLayoutViewerTemplate = require('templates/floorplanLayout-viewer.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'floorplanLayout',
  template: {
    'floorplanLayout': floorplanLayoutTemplate,
    'floorplanLayout-print': floorplanLayoutPrintTemplate,
    'floorplanLayout-viewer': floorplanLayoutViewerTemplate    
  },
  bindEvents: function() {
    var _self = this, $carousel, $messageInfo, $galleryHeading, $captionContainer;
    _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]');
    if (_self.$el.children('.tile-floorplan-layout').length) {
			_self.registerPopup(_self.$el.data('printEnable'), _self.$el.data('fullScreen'));
    } else if (_self.$el.hasClass('tile-floor-plan-viewer')) {
      _self.$carousel = _self.parentSelector.find('.mi-carousel');
      _self.$galleryWrapper = _self.parentSelector.find('.mi-gallery .article-content');
      if (_self.parentSelector.find('.slick-initialized').length) {
        _self.onSlickInit.call(_self);
      } else {
         _self.$carousel.on('init', function () {
          _self.onSlickInit.call(_self);
        });
      }

      _self.$messageInfo = _self.parentSelector.find('.l-message-info');
      _self.$galleryHeading =  _self.parentSelector.find('.l-gallery-heading');
      _self.$captionContainer = _self.parentSelector.find('.m-caption-container')

      _self.$carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var $currentSlide, $nextSlide;
        if (currentSlide !== nextSlide) {
          $currentSlide = slick.$slides.eq(currentSlide);
          $nextSlide = slick.$slides.eq(nextSlide);
          if ($nextSlide.data('caption')) {
            _self.$messageInfo.text($nextSlide.data('caption'));
            _self.$galleryHeading.text($nextSlide.data('title'));
            _self.$captionContainer.css("display", "table");
          } else {
            _self.$captionContainer.css("display", "none");
          }
        }
      });
    }
  },
	registerPopup: function (isShowPrint, isFullScreen) {
		var _self = this,
			popupConfig = {
      selector: '.tile-floorplan-layout .mi-popover',
      sourceBlock: '.modal-content'
			};

		if (isFullScreen) {
			popupConfig.alternateCloseMarkup = true;
			popupConfig.fullScreen = true;
			popupConfig.mainClass = 'mi-gallery mi-gallery-full';
		} else {
			popupConfig.addClassOnmfpWrap = true;
			popupConfig.showPrintButton = isShowPrint ? true : false;
			popupConfig.mfpWrapClassName = 'l-floorplan-print';
		}

		_self.floorplanLayoutStandardImagePopup = new Popup(popupConfig);
    _self.floorplanLayoutStandardImagePopup.register();

  },
  /**
   * This method is executed when the carousel is initialized. It performs a couple of operations mentioned in the comments below.
   * @return {Boolean} Success/Failure
   */
  onSlickInit: function _onSlickInit() {
    var _self = this,
      slick, currentSlideIndex, $currentSlide;
    //To focus image on initial load of gallery
    _self.$el.find('.slick-current').focus();

    //This is to load clicked image
    setTimeout(function() {
      var imageSelector = _self.parentSelector,
        imageToShow = imageSelector.find(".mi-carousel").data('mediaid'),
        showCategoryIndex = imageSelector.find('.slider-slide[data-slick-index="' + imageToShow + '"]').data('categoryIndex');
      if (imageToShow) {
        imageSelector.find('.mi-carousel').slick('slickGoTo', imageToShow).end()
          .find('#selectric-list0 li[data-index="' + showCategoryIndex + '"]').trigger("click");
      }
      
      slick = _self.$carousel.slick('getSlick');
      currentSlideIndex = slick.slickCurrentSlide();
      $currentSlide = slick.$slides.eq(currentSlideIndex);

      if ($currentSlide.data('caption')) {
        _self.$messageInfo.text($currentSlide.data('caption'));
        _self.$galleryHeading.text($currentSlide.data('title'));
        _self.$captionContainer.css("display", "table");
      } else {
        _self.$captionContainer.css("display", "none");
      }
    }, 0);
  }
});
